export default __webpack_public_path__ + "static/media/flatwires.b500b1ab.jpg";